<template>
<div class="hotel-list list-common">
  <!-- 筛选条件 -->
  <!-- <div class="query-div">
    <div class="selected-div">
      <div class="title">已选条件</div>
      <div class="selected-list flex-align-center" v-if="selectedList.length > 0">
        <div v-for="(item, index) in selectedList" :key="index">
          <span>{{item.name}}</span>
          <img src="../../assets/images/delete.png" @click="handleDeleteSelected(index, item)">
        </div>
        <span class="text-red pointer" v-if="selectedList.length > 0" @click="handleDeleteAll">清除全部</span>
      </div>
    </div>
    <div class="query-list">
      <div class="block" v-for="(item, index) in optionList" :key="index">
        <template v-if="item.option.length > 0">
          <div class="title">{{item.label}}</div>
          <div class="all-btn unselect" @click="handleSelectAll(index, item)" :class="{ select: item.isAllSelected }">全部</div>
          <div class="flex-1">
            <span @click="handleSelect(index, i, it)" class="mr20 unselect" :class="{ select: it.isSelected }" v-for="(it, i) in item.option" :key="i">{{it.name}}</span>
          </div>
        </template>
      </div>
    </div>
  </div> -->
  <div class="main-img">
    <img src="@/assets/images/home/trip-bg.jpg" alt="">
  </div>
  <!-- 排序 -->
  <div class="sort-div">
    <div v-for="(item, index) in sortArr" :key="index" :class="{ select: item.isAllSelected }" @click="handleSort(item)">
      <span :class="{ 'select': item.isSelected }">{{item.label}}</span>
      <div v-if="item.code === 'consumptionPerPerson'" class="arrows">
        <img v-if="item.status === 'asc'" src="../../assets/images/arrow-up-active.png">
        <img v-else src="../../assets/images/arrow-up.png">
        <img v-if="item.status === 'desc'" src="../../assets/images/arrow-down-active.png">
        <img v-else src="../../assets/images/arrow-down.png">
      </div>
    </div>
  </div>
  <!-- 产品列表 -->
  <div class="product-div">
    <div v-if="list.length > 0">
      <div class="product-content" v-for="(item, index) in list" :key="index">
        <div class="img">
          <img :src="item.mainPic">
        </div>
        <div class="detail">
          <div class="left">
            <div class="product-name">
              <span>{{item.name}}</span>
              <span class="grade">{{item.level}}星</span>
            </div>
            <div class="star">
              <el-rate
                v-model="item.avgReviewScore"
                disabled>
              </el-rate>
              <span>{{item.avgReviewScore || 0}}分</span>
            </div>
            <div class="comment">
              <span class="text-red">{{item.reviewTimes || 0}}</span>
              <span>人评论</span>
            </div>
            <div class="adr">
              <img src="../../assets/images/adr.png">
              <span>{{item.addressDetails}}</span>
            </div>
          </div>
          <div class="right flex-column-center">
            <div class="price">
              <span>¥</span>
              <span>{{item.consumptionPerPerson || 0}}</span>
              <span>起</span>
            </div>
            <div class="btn pointer" @click="handleToDetails(item.id)">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">暂无数据</div>
  </div>
  <div class="pagination-self" v-if="list.length > 0">
    <el-pagination
      background
      prev-text="上一页"
      next-text="下一页"
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="totalCount"
      >
    </el-pagination>
  </div>
</div>
</template>

<script>
import { queryListMixin } from '@/mixins/queryListMixin'
export default {
  name: 'retailList',
  mixins: [queryListMixin],
  data () {
    return {
      typeCode: 'retail_store',
      modules: 'RETAIL'
    }
  },
  created () {
    document.title = '零售预订'
  },
  methods: {
    handleToDetails (id) {
      if (!this.$parent.LoginBtnShow) {
        this.$parent.handleLogin()
        return
      }
      this.$router.push({ path: 'retailDetail', query: { id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.hotel-list{
  /* background-color: #F5F6F9; */
  overflow: hidden;
  margin-top: 24px;
}
</style>
